module.exports = __webpack_public_path__ + "static/media/kiwi-bird.b88bb0b8.svg";